package fr.frux.shared.data.mapper

import fr.frux.core.common.entitlements.AccountEntitlements
import fr.frux.core.common.entitlements.PremiumSource
import fr.frux.core.common.entitlements.ServerClock
import fr.frux.shared.domain.model.BlockedUser
import fr.frux.shared.domain.model.User
import fr.frux.shared.domain.model.UserProfile
import fr.frux.shared.dto.BlockedUserDto
import fr.frux.shared.dto.CurrentUserDto
import fr.frux.shared.dto.PremiumStateDto
import fr.frux.shared.dto.UserDto
import fr.frux.shared.dto.UserProfileDto
import kotlin.time.Instant

/** Traduction transport → domaine (#109), côté data. */
fun UserDto.toDomain(): User =
    User(
        id = id ?: 0,
        username = username,
        email = email,
        createdAt = createdAt?.toEpochMilliseconds() ?: 0,
    )

fun CurrentUserDto.toDomain(): User =
    User(
        id = id ?: 0,
        username = username,
        email = email,
        createdAt = createdAt?.toEpochMilliseconds() ?: 0,
    )

/**
 * Droits Frux+ (#454). Un `AD_FREE` sans fin devient [Instant.DISTANT_FUTURE] plutôt que `null`, qui
 * signifie « aucun ». Les autres droits à la carte (`OFFLINE_ZONE`, `MATURITY_ALERT`) ne sont pas
 * repris : aucun écran ne les lit encore (#108), ils remonteront avec #531. [serverClock] ancre les
 * échéances sur l'heure du serveur (#527). [accountId] identifie le compte pour la vidéo récompensée
 * (#531), [purchaseAccountRef] l'achat en store (#457).
 */
fun PremiumStateDto.toEntitlements(
    serverClock: ServerClock? = null,
    accountId: Long? = null,
    purchaseAccountRef: String? = null,
): AccountEntitlements {
    val adFree = temporaryGrants.filter { it.kind == AD_FREE }
    return AccountEntitlements(
        premium = active,
        premiumExpiresAt = expiresAt.takeIf { active },
        adFreeUntil =
            when {
                adFree.isEmpty() -> null
                adFree.any { it.expiresAt == null } -> Instant.DISTANT_FUTURE
                else -> adFree.mapNotNull { it.expiresAt }.max()
            },
        serverClock = serverClock,
        accountId = accountId,
        premiumSource = PremiumSource.fromWire(source).takeIf { active },
        purchaseAccountRef = purchaseAccountRef,
    )
}

private const val AD_FREE = "AD_FREE"

fun UserProfileDto.toDomain(): UserProfile =
    UserProfile(
        id = id,
        username = username,
        treesCount = treesCount,
        harvestsCount = harvestsCount,
        createdAt = createdAt.toEpochMilliseconds(),
        blockedByMe = blockedByMe,
    )

fun BlockedUserDto.toDomain(): BlockedUser =
    BlockedUser(userId = userId, username = username, blockedAt = blockedAt.toEpochMilliseconds())
